import classNames from "classnames";

import { useUserName } from "../../hooks/useUserName";
import type { DisplayUser } from "../../types";

import style from "./UserName.module.css"; // eslint-disable-line

interface UserNameProps {
  user?: DisplayUser;
  fallback?: string;
  color?: "gray";
}

export const UserName = ({ user, fallback, color }: UserNameProps) => {
  const { getUserName, getInitials } = useUserName();
  const displayName = getUserName(user, fallback);
  if (!displayName) {
    return null;
  }

  const initial = getInitials(user);

  return (
    <div className={style.wrapper}>
      <div className={classNames([style.avatar, color ? style[color] : ""])}>{initial}</div>
      <span className={style.name} title={displayName}>
        {displayName}
      </span>
    </div>
  );
};
